import { render, staticRenderFns } from "./LoginHistoryTable.vue?vue&type=template&id=3aa2a780"
import script from "./LoginHistoryTable.vue?vue&type=script&lang=js"
export * from "./LoginHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports